import { ActionType } from '../types/action-type';
import { Field } from './field';
import { ApproverType } from '../types/approver-type';
import { OrgUnitType } from '../types/org-unit-type';
import { ActionFormData } from '../custom-field-parameter/action-form-data';
import { ApproverDataToJson } from '../data-to-json/approver-data-to-json';

export class Form {
  id: string | undefined;
  name: string | undefined;
  groupName: string | undefined;
  tag: string | undefined;
  timestamp: string | Date | undefined;
  visibleForGroups: string[] | undefined;
  owners: string[] | undefined;
  visible: boolean | undefined;
  operators: string[] | undefined;
  readers: string[] | undefined;
  tester: string[] | undefined;
  showLastOperator: boolean | undefined;
  allowCancelUntilProgressStarts: boolean | undefined;
  approverTypes: ApproverType[] | undefined = [];
  approverData: string | undefined;
  approverDataCustomParameter: ApproverDataToJson[] | undefined = [];
  orderedApprovals: boolean | undefined;
  actionType: ActionType | null | undefined;
  actionData: string | undefined;
  actionDataCustomParameter: ActionFormData | undefined = new ActionFormData(undefined);
  fields: Field[] | undefined;
  orgUnitType: OrgUnitType | undefined;
  orgUnitName: string | undefined;
  privacyReason: string | undefined;
  dataFields: string | undefined;
  dataFieldsCustomParameter: string[] | undefined;
  legalBasis: string | undefined;
  dataTransmission: string | undefined;
  externalDataTransmission: string | undefined;
  storagePeriod: number | undefined;
  contactEmail: string | undefined;
  contactTelephone: string | undefined;
  approvalDataProtectionOfficer: string | undefined;
  approvalDataProtectionOfficerAt: Date | undefined;
  createdByFirstName: string | undefined;
  createdByLastName: string | undefined;
  lastApproved: Form | undefined;
}
